module.exports = __webpack_public_path__ + "0002dde4f034fb9f3263e331d623346c.png";